import 'typeface-roboto';
import React from 'react';
import {render} from 'react-dom';
import App from './client/app';

render(
	React.createElement(App),
	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js